import { SubGameType } from "types/game";

import { CATEGORY_CODE } from "./type";
import { ImgProvider } from "assets/desktop/images/navSubgame";
import { ProviderLogo } from "assets/desktop/images/providerList";

export const listSportGame: SubGameType[] = [
  {
    game_code: "",
    name: "SUPER體育",
    provider_code: "SPSB",
    provider_name: "SUPER sportbook",
    type: CATEGORY_CODE.SPORT,
    featured: "",
    new_arrive: "",
    picture: ImgProvider.SportSUPER,
    icon: ProviderLogo.SportSUPER,
  },
  {
    game_code: "",
    name: "阿拉八體育",
    provider_code: "OBSB",
    provider_name: "Alaba Sports",
    type: CATEGORY_CODE.SPORT,
    featured: "",
    new_arrive: "",
    picture: ImgProvider.SportOBSB,
    icon: ProviderLogo.SportOBSB,
  },
];
